export const QueryKey = 'timeline'
export const ActionQueryKey = 'timeline-actions'
export const CareTimeline = '/api/v1/caretimeline'
export const Actions = `${CareTimeline}/actions`
export const CompleteAction = (id: string): string =>
  `/api/v1/caretimeline/execution/action/${id}/complete`
